export enum CurrentTypeModule{
    NoneModule,
    StyleModule,
    EspModule,
    LogoModule,
    S7Module,
}